(function ($) {
  DJ.addBehavior('mediaSlider', '[data-media-image-slider]', {
    attach: function () {
      const element = jQuery(this);

      element.slick({
        prevArrow: `<button type="button" class="slick-prev media-image-slider__arrow  media-image-slider__arrow--back">
                    </button>`,
        nextArrow: `<button type="button" class="slick-next media-image-slider__arrow">
                    </button>`,
        centerMode: true,
        centerPadding: '50px',
        slidesToShow: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerPadding: '30px',
            }
          },
        ]
      });
    }
  });
})(jQuery);
